/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import { checkIfStringIsZeroOrEmpty } from '../../../utils/StringUtils/StringUtils';
import { convertStringToNumber } from '../../../utils/ConvertStringToNumber/convertStringToNumber';

const ParcelRateSelectCell = ({
  type = 'text',
  field,
  data,
  setData,
  customClassName = '',
  index,
  recentlyUpdatedData,
  originalData,
  options = [], // New prop for select options
  isNew = false,
}) => {
  const handleChange = (e) => {
    const v = e.target.value === '' ? null : e.target.value;
    const value = type === 'number' ? convertStringToNumber(v) : v;
    setData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    );
  };

  // Get the value for display in the select
  const getSelectValue = () => {
    const rawValue = data[index]?.[field];
    return checkIfStringIsZeroOrEmpty(rawValue);
  };

  return (
    <div className="text-xs inline-block">
      <div className="relative">
        <select
          value={getSelectValue()}
          onChange={handleChange}
          className={classNames(
            'outline-none border-b border-blue-800 focus:border-blue-400 px-2',
            customClassName,
            !!originalData &&
              data[index]?.[field] !== originalData?.[index]?.[field] &&
              'bg-green-200',
            (data[index]?.[field] !== recentlyUpdatedData?.[index]?.[field] ||
              isNew) &&
              '!bg-red-200',
          )}
        >
          {options.map((option) => (
            <option
              className={classNames(
                option.isDisabled ? 'bg-gray-200' : 'text-blue-800',
              )}
              key={option.value}
              value={option.value}
              disabled={option.isDisabled}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ParcelRateSelectCell;
